function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "33",
  height: "33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.402 1c.978 0 1.734.592 2.097 1.318l.004.008 3.542 7.238 7.85 1.181-.002.001c.939.121 1.57.828 1.828 1.512l.006.017.006.018c.284.85.082 1.74-.569 2.39l-.004.004-5.703 5.65 1.337 7.967c.18.91-.241 1.734-.827 2.236l-.057.05-.064.039c-.7.437-1.541.538-2.358.176l.02-.102-.034.067-7.018-3.79-7.017 3.79-.013.008-.014.007c-.796.398-1.714.272-2.4-.156l-.063-.04-.057-.049c-.586-.502-1.008-1.327-.828-2.236L7.4 20.337l-5.702-5.65-.003-.003a2.286 2.286 0 01-.57-2.391l.006-.018.007-.017c.256-.684.888-1.39 1.826-1.512v0l7.848-1.182 3.543-7.238.004-.008C14.711 1.615 15.456 1 16.402 1z",
  fill: "#FACC15",
  stroke: "#FACC15",
  strokeWidth: "2"
}));